import { Analytics } from './analytics';

$("[data-ecommerce-details-product-model]").each((i, e) => {
  const itemId = e.dataset["ecommerceDetailsProductId"];
  const itemName = e.dataset["ecommerceDetailsProductName"];
  const affiliation = e.dataset["ecommerceDetailsProductAffiliation"];
  const currency = e.dataset["ecommerceDetailsProductCurrency"];
  const discount = e.dataset["ecommerceDetailsProductDiscount"];
  const itemBrand = e.dataset["ecommerceDetailsProductItemBrand"];
  const itemCategory = e.dataset["ecommerceDetailsProductItemCategory"];
  const itemCategory2 = e.dataset["ecommerceDetailsProductItemCategory2"]
  const itemCategory3 = e.dataset["ecommerceDetailsProductItemCategory3"];
  const itemVariant = e.dataset["ecommerceDetailsProductItemVariant"];
  const price = e.dataset["ecommerceDetailsProductPrice"];
  const quantity = e.dataset["ecommerceDetailsProductQuantity"];

  const item = {
    "item_id": itemId,
    "item_name": itemName,
    "affiliation": affiliation,
    "currency": currency,
    "discount": discount,
    "item_brand": itemBrand,
    "item_category": itemCategory,
    "item_category2": itemCategory2,
    "item_category3": itemCategory3,
    "item_variant": itemVariant,
    "price": price,
    "quantity": quantity
  }

  Object.keys(item).forEach(key => item[key] === undefined ? delete item[key] : {});

  Analytics.sendRawEvent({
    "event": "view_item",
    "ecommerce": {
      "value": price,
      "currency": currency,
      "items": [
        item
      ]
    }
  });
});